exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-align-bottom[data-v-2bc2b2a7] {\n  align-self: flex-end;\n}\n.flex[data-v-2bc2b2a7] {\n  display: flex;\n}\n", ""]);

// exports
